import { render, staticRenderFns } from "./SelectorTicketType.vue?vue&type=template&id=40a7518c&scoped=true"
import script from "./SelectorTicketType.vue?vue&type=script&lang=js"
export * from "./SelectorTicketType.vue?vue&type=script&lang=js"
import style0 from "./SelectorTicketType.vue?vue&type=style&index=0&id=40a7518c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a7518c",
  null
  
)

export default component.exports